
    <div class="upload-container">
      <div 
        class="upload-area"
        [class.dragover]="isDragging"
        [class.has-file]="currentFile"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        
        <ng-container *ngIf="!currentFile">
          <input
            #fileInput
            type="file"
            [accept]="acceptedFiles"
            (change)="onFileSelected($event)"
            style="display: none">
          
          <div class="upload-prompt" @fadeInOut>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="upload-icon">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M12 4L12 16M12 4L8 8M12 4L16 8M4 13.8V17.6C4 18.9255 5.07452 20 6.4 20H17.6C18.9255 20 20 18.9255 20 17.6V13.8"/>
            </svg>
            <span class="upload-text">Arrastra tu archivo o</span>
            <button class="select-btn ripple" (click)="fileInput.click()">
              selecciona aquí
            </button>
          </div>
        </ng-container>

        <div class="file-info" *ngIf="currentFile" @fadeInOut>
          <div class="file-details">
            <span class="file-name">{{ currentFile ? currentFile.name : '' }}</span>
            <span class="file-size">{{ formatFileSize(currentFile ? currentFile.size:0) }}</span>
          </div>
          <button class="remove-btn" (click)="removeFile()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
      </div>

      <button 
        class="upload-btn"
        [class.active]="currentFile"
        [disabled]="!currentFile"
        (click)="uploadFile()">
        <span class="btn-content">
          {{ currentFile ? 'Subir archivo' : 'Selecciona un archivo' }}
        </span>
      </button>
    </div>
